import StatusBar from '../components/StatusBar/StatusBar'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { updateStatusBar, toggleStatusBar, resetStateStatusBar } from '../modules/settings'

const mapStateToProps = state => ({
  statusBarContent: state.settings.statusBarContent,
  visibleStatusBar: state.settings.visibleStatusBar
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateStatusBar,
  toggleStatusBar,
  resetStateStatusBar,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusBar)



// WEBPACK FOOTER //
// ./src/containers/StatusBarContainer.js